"use client";
import { classes } from "@/classnames";
import { FileInput, Input, Select, TextArea } from "@/components/ui";
import { Modal } from "@/components/ui/modal";
import { SelectOption } from "@/components/ui/select/select.types";
import { SubmitButton } from "@/components/ui/submit-button";
import { postContactUsForm } from "@/features";
import { useLoading } from "@/hooks/use-loading";
import { useModal } from "@/hooks/use-modal";
import { ContactFormData } from "@/types/forms";
import { getSelectOptions } from "@/utils";
import { yupResolver } from "@hookform/resolvers/yup";
import { SubmitHandler, useForm } from "react-hook-form";
import { SingleValue } from "react-select";
import { FormWrapper } from "../form-wrapper";
import { ContactUsEmails } from "./contact-us-emails";
import { IContactUs } from "./contact-us.types";
import { contactUsFormValidationSchema } from "./contact-us.validate";
import { useState } from "react";

export const ContuctUs: IContactUs = ({ topics, emails }) => {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    resetField,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm<ContactFormData>({
    resolver: yupResolver(contactUsFormValidationSchema as any),
  });
  const [isInputNeededClear, setIsInputNeededClear] = useState(false);

  const { loading, setLoading } = useLoading();

  const { isVisible, hide, open } = useModal();

  const onSubmit: SubmitHandler<ContactFormData> = async (data) => {
    if (!data.file?.length) delete data.file;
    setLoading(true);
    const response = await postContactUsForm(data);
    setLoading(false);

    if (!response.error) {
      reset();
      resetField("contact_form_topic_id");
      setIsInputNeededClear(true);
      open();
    }
  };

  const options = getSelectOptions(topics);

  const contact_form_topic_id = getValues().contact_form_topic_id;

  const value = options.find((el) => el.value === contact_form_topic_id);

  const onSelect = (value: SingleValue<SelectOption>) => {
    const newValue = value?.value;
    newValue ? setValue("contact_form_topic_id", newValue as number) : resetField("contact_form_topic_id");
    clearErrors("contact_form_topic_id");
  };

  return (
    <FormWrapper
      title="Contact us"
      titleInfo={<ContactUsEmails emails={emails} />}
    >
      <form
        autoComplete="off"
        className={classes.Form}
        onSubmit={handleSubmit(onSubmit)}
        suppressHydrationWarning
      >
        <Input
          {...register("name")}
          label="name"
          required
          error={errors.name?.message}
        />
        <Input
          {...register("title")}
          required
          label="title"
          error={errors.title?.message}
        />
        <Input
          {...register("last_name")}
          label="last name"
          error={errors.last_name?.message}
        />
        <TextArea
          {...register("message")}
          className="row-span-2"
          required
          label="Message"
          error={errors.message?.message}
        />

        <Input
          type="email"
          {...register("email")}
          label="email"
          required
          error={errors.email?.message}
        />

        <Select
          onSelect={onSelect}
          value={value}
          label="select a topic"
          required
          error={errors.contact_form_topic_id?.message}
          options={options}
        />

        <FileInput
          {...register("file")}
          label="attach a file"
          error={errors.file?.message}
          isInputNeededClear={isInputNeededClear}
          setIsInputNeededClear={setIsInputNeededClear}
        />

        <SubmitButton loading={loading} />
      </form>

      <Modal
        isVisible={isVisible}
        hide={hide}
      >
        <h5 className="text-[40px] font-[600] leading-[120%] uppercase text-white text-center">
          The Message Was Sent Successfully
        </h5>
        <p className="text-[20px] font-[600] text-text-04 text-center">
          Thank you for getting in touch! We appreciate your interest. Our team will review your message and get back to
          you shortly
        </p>
      </Modal>
    </FormWrapper>
  );
};
